import actionTypes from 'dashboard/actions/eft-history/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_EFT_EXTENSIONS_SUCCESS:
      return [...action.extensions];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/eft-history/extensions.js